import { useEnterAuthSession } from './session-provider';

export interface EnterAuthToken {
  /** 静默获取已登录用户 token；不会触发 Fingerprint 或 Risk Session。 */
  getAccessToken(): Promise<string>;
}

/** 将 Auth0 的 token 方法收敛为 API 包需要的最小接口。 */
export function useEnterAuthToken(): EnterAuthToken {
  const { getAccessToken } = useEnterAuthSession();
  return { getAccessToken };
}
